
<template>
    <div>
        <v-layout>
            <v-flex>
                <v-card>
                    <v-toolbar flat dark color="secondary">
                        <v-toolbar-title @click="showCard=!showCard" :style="$store.state.textFormatting.headers">
                            System Stats (24h)
                        </v-toolbar-title>
                        
                        <v-spacer> </v-spacer>
                        
                        <v-flex shrink class="px-1">
                            <v-toolbar-title>
                                <small>
                                    <small :style="$store.state.textFormatting.main">
                                        {{ updatedStr }} 
                                    </small>
                                </small>
                            </v-toolbar-title>
                        </v-flex>
                        
                        <info>
                            <template slot>
                                <h3> System statistics in the last 24 hours </h3>
                            </template>
                            <template slot="body">
                                <p> A list of statistics for the whole system</p>
                                <ul>
                                    <li v-for="(i, key) in statsList" :key="key"><b>{{i.name}}</b>: {{i.desc}}</li>
                                </ul>
                                <br />
                                <p> Also displays status of ingest collectors. We use a key to colour the collectors as follows (based on when we have last received the last update from them): </p>
                                <ul>
                                    <li> <v-chip color="success" :style="$store.state.textFormatting.main" text-color="#000000" dark> &lt;1 hour </v-chip> </li>
                                    <li> <v-chip color="yellow" :style="$store.state.textFormatting.main" text-color="#000000" dark> &lt;6 hours </v-chip> </li>
                                    <li> <v-chip color="orange" :style="$store.state.textFormatting.main" text-color="#000000" dark> &lt;24 hours </v-chip> </li>
                                    <li> <v-chip color="red" :style="$store.state.textFormatting.main" text-color="#000000" dark> &gt;24 hours </v-chip> </li>
                                </ul>
                                <p> Press the <v-btn small color='accent' fab dark> <b>+</b> </v-btn> button to see the table of collectors. </p>
                            </template>
                            <template slot="action">
                                <v-btn color="primary" flat to="/statistics" :style="$store.state.textFormatting.main">More Stats</v-btn>
                            </template>
                        </info>
                    </v-toolbar>

                    <!-- The bellow could be summerised in a v-for and would only take up 5 lines -->

                    <v-card-text v-if="showCard">
                        <v-progress-circular v-if="loading" indeterminate color="primary" ></v-progress-circular>
                        <v-layout wrap v-if="isdata">
                            <v-flex xs6 md4 xl6>
                                <v-card>
                                    <v-card-text>
                                        <h4 display-1 :style="$store.state.textFormatting.main"> Episodes: {{ epsStr }} </h4>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                            <v-flex xs6 md4 xl6>
                                <v-card>
                                    <v-card-text>
                                        <h4 display-1 :style="$store.state.textFormatting.main"> Events: {{ evsStr }} </h4>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                            <v-flex xs6 md4 xl6>
                                <v-card>
                                    <v-card-text>
                                        <h4 display-1 :style="$store.state.textFormatting.main"> Path Changes: {{ pchStr }} </h4>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                            <v-flex xs6 md4 xl6>
                                <v-card>
                                    <v-card-text>
                                        <h4 display-1 :style="$store.state.textFormatting.main"> Own. Changes: {{ ownStr }} </h4>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                            <v-flex xs6 md4 xl6>
                                <v-card>
                                    <v-card-text>
                                        <h4 display-1 :style="$store.state.textFormatting.main"> Unique Prefixes: {{ unpStr }} </h4>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                            <v-flex xs6 md4 xl6>
                                <v-card>
                                    <v-card-text>
                                        <h4 display-1 :style="$store.state.textFormatting.main"> New Prefix Count: {{ nprStr }} </h4>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
                <v-divider />
                <v-card>
                    <v-layout justify-center align-center>
                        <v-flex class="px-2 py-4" justify-center align-center shrink>
                            <v-card :color="collCardColor">
                                <v-layout justify-center align-center>
                                    <v-flex class="px-4 py-2" shrink>
                                        <h4 :style="$store.state.textFormatting.main">
                                            {{ collCollated }}
                                            <br />
                                            <v-tooltip top eager>
                                                <span slot="activator" :style="$store.state.textFormatting.main">
                                                    <small v-if="collMax">
                                                        Last timestamp: {{ collMax.date }} {{ collMax.time }} ({{ timeago }})
                                                    </small>        
                                                </span>
                                                <span :style="$store.state.textFormatting.main">
                                                    Last ingested message timestamp: {{ collMax.date }} {{ collMax.time }}
                                                </span>
                                            </v-tooltip>
                                            
                                        </h4>
                                    </v-flex>
                                    <v-flex class="px-2 py-2" shrink>
                                        <v-btn small color='accent' fab dark @click='showCollCard=!showCollCard' v-if="!showCollCard"> <b>+</b> </v-btn>
                                        <v-btn small color='accent' fab dark @click='showCollCard=!showCollCard' v-if="showCollCard"> <b>-</b> </v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-card>
                        </v-flex>
                    </v-layout>
                    <v-layout justify-center align-center>
                        <v-flex class="px-2 py-2" justify-center align-center shrink>
                            <v-card v-if="showCollCard">
                                <v-flex class="px-2 py-2">
                                    <v-data-table  :headers="collStatsHeaders" :items="collStat"
                                        :rows-per-page-items="rowsPerPageItems" :pagination.sync="pagination">
                                        <template slot="headerCell" slot-scope="props">
                                            <v-tooltip top eager>
                                            <span slot="activator" :style="$store.state.textFormatting.main">
                                                {{ props.header.text }}
                                            </span>
                                            <span :style="$store.state.textFormatting.main">
                                                {{ props.header.ad_text }}
                                            </span>
                                            </v-tooltip>
                                        </template>
                                        <template slot="items" slot-scope="props">
                                            <tr>
                                                <td class="text-xs-center" :style="$store.state.textFormatting.main"> {{ props.item.collector }} </td>
                                                <td class="text-xs-center" :style="$store.state.textFormatting.main" v-if="props.item.color=='red'">
                                                    <v-chip :color="props.item.color" :style="$store.state.textFormatting.main" text-color="#000000" dark> {{ props.item.datetime.date }} </v-chip>
                                                </td>
                                                <td class="text-xs-center" :style="$store.state.textFormatting.main" v-if="props.item.color!='red'">
                                                    {{ props.item.datetime.date }}
                                                </td>
                                                <td class="text-xs-center" :style="$store.state.textFormatting.main">
                                                    <v-chip :color="props.item.color" :style="$store.state.textFormatting.main" text-color="#000000" dark> {{ props.item.datetime.time }} </v-chip>
                                                </td>
                                            </tr>
                                        </template>
                                    </v-data-table>
                                </v-flex>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-card>



                <!-- <v-card v-if="!isdata">
                    <v-card-title> <h1>{{StatsForLastDay}} </h1> </v-card-title>
                </v-card> -->
            </v-flex>
        </v-layout>
    </div>
</template>

<script>

import { API, graphqlOperation } from 'aws-amplify';
import info from './infopopout.vue'

export default {
    name: 'eventtoepisodestats',
    components: {
        info
    },
    data () {
        return {
            StatsForLastDay: '',
            updatedStr: "",
            loading: false,
            epsStr: "",
            evsStr: "",
            pchStr: "",
            ownStr: "",
            unpStr: "",
            nprStr: "",
            isdata: false,
            statsList: [{name: "Episodes", desc: "Count of the Episodes in last 24 hours", addInfo: "What is an Episode?"},
                        {name: "Event", desc: "Count of the Events in the last 24 Hours", addInfo: "What is an Event?"},
                        {name: "Path Changes", desc: "Number of events where the origin AS stays the same, over the last 24 hours", addInfo: "What is an Event?"},
                        {name: "Own. Changes", desc: "Number of times a prefix's owner AS has changed (excludes first seen prefix events)", addInfo: "What is an Event?"},
                        {name: "Unique Prefixes", desc: "Count of the unique prefixes seen within the last 24 hours", addInfo: "What is an Event?"},
                        {name: "New Prefixes", desc: "Count of the new prefixes which we haven't seen previously", addInfo: "What is an Event?"}],
            showCard: true,
            collStat: [],
            showCollCard: false,
            collCardColor: '',
            collCollated: '',
            collMax: false,
            collStatsHeaders: [
                {text: 'Collector', ad_text: 'Collector (anonymised if not a RouteViews collector)', value: 'name', align: 'centre'},
                {text: 'Date', ad_text: 'Date of last ingested message', value: 'ingest_timestamp', align: 'centre'},
                {text: 'Time', ad_text: 'Time of last ingested message', value: 'ingest_timestamp', align: 'centre'}
            ],
            pagination: {
                rowsPerPage: 10,
                sortBy: 'ingest_timestamp',
                descending: false
            },
            rowsPerPageItems: [10, 20, 30, 40, 50, 100],
            timeago: ''

        }
    },

    mounted() {
        this.getdata();
        this.getCollectorStats();
    },
    methods: {
        getCollColor: function (t) {

            var nt = Math.floor(new Date() / 1000)
            if (t > nt - 3600) {
                return 'success'
            } else if (t > nt - 3600 * 6) {
                return 'yellow'
            } else if (t > nt - 3600 * 24) {
                return 'orange'
            } else {
                return 'red'
            }
        },
        getCollectorStats: async function () {
            try {
                var mincolor;
                var mintime;
                var maxtime;
                var collateStat = {
                    'gt24': 0,
                    'lt24': 0,
                    'lt6': 0,
                    'lt1': 0
                }
                var mapCol = {
                    'success': 'lt1',
                    'yellow': 'lt6',
                    'orange': 'lt24',
                    'red': 'gt24'
                }
                this.collStat = [];
                this.collCollated = ''
                var query = `query getCollectorStats { getCollectorStats {
                        collector
                        ingest_timestamp
                    }
                }`;
                const collStats = await API.graphql(graphqlOperation(query))
                //console.log(collStats)
                var collData = collStats.data.getCollectorStats;
                var j = 1;
                if (collData) {
                    if (collData.length > 0) {
                        mintime = collData[0].ingest_timestamp;
                        maxtime = collData[0].ingest_timestamp;
                        for (var i = 0 ; i < collData.length ; i++ ) {
                            collData[i].color = this.getCollColor(collData[i].ingest_timestamp)
                            collateStat[mapCol[collData[i].color]] += 1
                            collData[i].datetime = this.convertEpochtoTimeDate(collData[i].ingest_timestamp);
                            collData[i].collector = collData[i].collector.replace('-prod', '')
                            if (collData[i].collector.includes('route-views')) {
                                if (collData[i].collector.includes('route-views.')) {
                                    collData[i].collector = 'RouteViews ' + collData[i].collector.split('route-views.')[1]
                                } else {
                                    collData[i].collector = 'RouteViews ' + collData[i].collector.split('route-views')[1]
                                }
                            }
                            if (collData[i].collector.includes('rrc')) {
                                collData[i].collector = 'RIPE RIS Live ' + collData[i].collector.split('rrc')[1]
                            }
                            if (collData[i].ingest_timestamp < mintime) {
                                mintime = collData[i].ingest_timestamp;
                            }
                            if (collData[i].ingest_timestamp > maxtime) {
                                maxtime = collData[i].ingest_timestamp;
                            }
                        }
                        for (var i = 0 ; i < collData.length ; i++ ) {
                            if (collData[i].ingest_timestamp == mintime) {
                                mincolor = collData[i].color
                            }
                        }
                        if (collateStat['gt24'] > 0) {
                            this.collCollated = collateStat['gt24'].toString() + " collectors >24h old" 
                        } else if (collateStat['lt24'] > 0) {
                            this.collCollated = collateStat['lt24'].toString() + " collectors >6h old" 
                        } else if (collateStat['lt6'] > 0) {
                            this.collCollated = collateStat['lt6'].toString() + " collectors >1h old" 
                        } else {
                            this.collCollated = 'All collectors fresh (<1h old)'
                        }
                    }
                }
                this.collStat = collData;
                this.collCardColor = mincolor;
                var nt = Math.floor(new Date() / 1000)
                this.collMax = this.convertEpochtoTimeDate(maxtime);
                // minute / second / hour (sort this)
                this.timeago = this.minSeconds(nt - maxtime) + " ago"
            } catch (err) {
                console.log(err)
            }
        },
        minSeconds: function (t) {
            if (t < 60) {
                return t + "s"
            } else if (t < 3600) {
                var min = Math.floor(t / 60)
                var sec = t % 60
                if (sec != 0) {
                    return min + "m " + sec + "s"
                } else {
                    return min + "m"
                }
            } else {
                var hr = Math.floor(t / 3600)
                var min = Math.floor(t / 60) - hr * 60
                var sec = t % 60
                if (sec != 0) {
                    if (min != 0) {
                        return hr + "h " + min + "m " + sec + "s"
                    } else {
                        return hr + "h " + sec + "s"
                    }
                } else {
                    if (min != 0) {
                        return hr + "h " + min + "m"
                    } else {
                        return hr + "h"
                    }
                }
            }
        },
        getdata:  async function () {
            try {
            this.loading = true;
            var query = `query getEpisodeStatsAll { getScoredEpisodeStats (interval_length_seconds: 86400, interval_count: 1, page_offset: 0, page_rows:1) {
                interval_start
                total_episode_count
                total_event_count
                unique_prefix_count
                episodes_for_prefix
                hijack_count
                first_obs_count
                path_change_count
                restricted_dns_count
                controlled_prefix_count
                bogon_count
                route_leak_count
                } 
            }`;
            const episodeStats = await API.graphql(graphqlOperation(query));   
            var statsForLastDay = episodeStats.data.getScoredEpisodeStats[0]
            if (episodeStats.data.getScoredEpisodeStats[0] == undefined) {
                statsForLastDay = `There have been no new events or episodes processed in the last 24 hours. Please try again later.`
                this.isdata = false
            } else {
                statsForLastDay.mean_events_per_episode = (statsForLastDay.total_event_count/statsForLastDay.total_episode_count).toFixed(2)
            }
            this.StatsForLastDay = statsForLastDay
            this.epsStr = this.getCommaSep(statsForLastDay.total_episode_count)
            this.evsStr = this.getCommaSep(statsForLastDay.total_event_count)
            this.pchStr = this.getCommaSep(statsForLastDay.path_change_count)
            this.ownStr = this.getCommaSep(statsForLastDay.hijack_count)
            this.unpStr = this.getCommaSep(statsForLastDay.unique_prefix_count)
            this.nprStr = this.getCommaSep(statsForLastDay.first_obs_count)
            
            this.loading=false
            }
            catch (err){
                this.data = `There have been no new events or episodes processed in the last 24 hours. Please try again later.`
                this.epsStr = 0
                this.evsStr = 0
                this.pchStr = 0
                this.ownStr = 0
                this.unpStr = 0
                this.nprStr = 0
                this.isdata = false
                console.log(err)
            }
            this.getUniquePrefs();
        },
        getCommaSep: function (x) {
            try {
                return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            } catch (err) {
                if (!x) {
                    return 0
                } else {
                    return x
                }
            }
        },
        getUniquePrefs: async function () {
            // Added because getting unique prefixes over 24 hours is more than taking a count of unique prefixes each hour then adding them up
            try{
                this.loading = true;
                var dd = Math.floor(new Date() / 1000) - 86400;

                console.log("uniqueprefsquery")
                var query = `query getUniquePrefixes {
                    getUniquePrefixes(start_time: ` + dd + `) {
                        distinct_prefixes
                    }
                }`;
                const result = await API.graphql(graphqlOperation(query));
                console.log(result)
                var res1 = result.data.getUniquePrefixes[0];
                if (!res1 || res1 == undefined) {
                    console.log("no result for unique prefs query");
                    this.isdata = true
                    this.loading = false
                    var d = new Date();
                    var day = ("0" + d.getUTCDate()).slice(-2);
                    var month = ("0"+(d.getUTCMonth()+1)).slice(-2)
                    var year = d.getUTCFullYear()
                    var dateFormatted = day + "/" + month + "/" + year
                    var timeFormatted = ("0" + d.getUTCHours()).slice(-2) + ":" + ("0" + d.getUTCMinutes()).slice(-2);
                    this.updatedStr = "U: " + dateFormatted + " " + timeFormatted
                } else {
                    console.log(res1);
                    //this.StatsForLastDay.unique_prefix_count = res1["distinct_prefixes"];
                    this.unpStr = this.getCommaSep(res1["distinct_prefixes"]);
                    this.isdata = true
                    this.loading = false
                    var d = new Date();
                    var day = ("0" + d.getUTCDate()).slice(-2);
                    var month = ("0"+(d.getUTCMonth()+1)).slice(-2)
                    var year = d.getUTCFullYear()
                    var dateFormatted = day + "/" + month + "/" + year
                    var timeFormatted = ("0" + d.getUTCHours()).slice(-2) + ":" + ("0" + d.getUTCMinutes()).slice(-2);
                    this.updatedStr = "U: " + dateFormatted + " " + timeFormatted
                }
            } catch(err) {
                console.log(err)
                this.isdata = true
                this.loading = false
                var d = new Date();
                var day = ("0" + d.getUTCDate()).slice(-2);
                var month = ("0"+(d.getUTCMonth()+1)).slice(-2)
                var year = d.getUTCFullYear()
                var dateFormatted = day + "/" + month + "/" + year
                var timeFormatted = ("0" + d.getUTCHours()).slice(-2) + ":" + ("0" + d.getUTCMinutes()).slice(-2);
                this.updatedStr = "U: " + dateFormatted + " " + timeFormatted
            }
            
        },
        convertEpochtoTimeDate: function (epochTime) {
            try {
                var d = new Date( epochTime *1000);

                var day = ("0" + d.getUTCDate()).slice(-2);
                var month = ("0"+(d.getUTCMonth()+1)).slice(-2)
                var year = d.getUTCFullYear()
                var dateFormatted = day + "/" + month + "/" + year
                var timeFormatted = ("0" + d.getUTCHours()).slice(-2) + ":" + ("0" + d.getUTCMinutes()).slice(-2);

                var dateTime  = {"date": dateFormatted, "time": timeFormatted}

                return dateTime
            }
            catch(err) {
                console.log(err)
            }

        }
    }
}
</script>

